module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// /~/i18next-browser-languagedetector/index.js
// module id = 918
// module chunks = 31